<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent && isAllowedForItem">
  <app-full-page-message *ngIf="isAllowedForItem.status != 1"></app-full-page-message>
  <div
    *ngIf="isAllowedForItem.status == 1 && localService.languageContent.billing && localService.languageContent.common && billingMode">
    <app-business-deductive *ngIf="businessId != '' && businessId != '0'" [currentBusinessId]="businessId"
      [businesses]="localService.loggedMember.businesses"></app-business-deductive>
    <div *ngIf="billedItems && !billedItems.isActionsAllowed && billedItems.products.length == 0">
      <div class="row">
        <div class="col-md-12" style="text-align:center;margin-top:10%">
          <div style="font-size: 25px;">{{localService.languageContent.billing.unavailable}}</div>
        </div>
      </div>
    </div>
    <span style="display:none;">
      <i class="material-icons on_language_changed" style="float:left;" (click)="onLoad(true)">replay_circle_filled</i>
      <i class="material-icons on_local_printer_changed" style="float:left;"
        (click)="onCheckLocalPrinter()">replay_circle_filled</i>
    </span>
    <div class="banner row_header_dum freeze_height"
      *ngIf="!isCompactQuickPick && wrapper && billedItems && billedItems.isActionsAllowed">
      <div *ngIf="isSearchbarShow">
        <div class="row">
          <div class="col-sm-5">
            <div class="row">
              <div class="col-6">
                <label *ngIf="isExcludedEnabled" style="font-weight: normal; margin-left: 15px;"
                  title="{{localService.languageContent.common.is_excluded}}">
                  <input type="checkbox" [(ngModel)]="isExcluded" [disabled]="billingId && billingId.length > 5"
                    (change)="ensureAllProducts(true)" />
                  <span class="normal_color">&nbsp;</span>
                </label>
                <div [ngClass]="isExcludedEnabled ? 'exclude_price_active' : ''">
                  <i *ngIf="billingId != '0' && billedItems.bill.v4 == '0' && billedItems.status != BillingStatus.Draft && billedItems.status != BillingStatus.Delivered && billedItems.status != BillingStatus.Rejected && billedItems.status != BillingStatus.Cancelled"
                    class="material-icons delete_icon action_icon" (click)="onUpdateStatus(BillingStatus.Cancelled)"
                    title="{{localService.languageContent.billing.cancel}}">cancel</i>
                  <i *ngIf="isAmountPaid()" class="material-icons icon_adjust bill_paid">paid</i>
                  <i *ngIf="billedItems.status == BillingStatus.Cancelled" class="material-icons action_icon"
                    title="{{localService.languageContent.billing.undo}}" (click)="onAction(11)">undo</i>
                  <div class="blling_status" *ngIf="billedItems.bill.v2 != ''" (click)="onShowHistory()">
                    <span>{{localService.getText(localService.billingStatus,billedItems.status)}}</span>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <ngx-select [disabled]="interactionType == 1 || billedItems.bill.v4 != '0'"
                  [(ngModel)]="billedItems.bill.v3" [noAutoComplete]="true" [items]="initialization.businessTypes"
                  [optionValueField]="'key'" [optionTextField]="'value'" (select)="onUpdateFromDropdown(1)"
                  title="{{localService.languageContent.billing.business_type}}"
                  placeholder="{{localService.languageContent.billing.business_type}}">
                </ngx-select>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-5" style="text-align:right;">
                <ngx-select [(ngModel)]="selectedCustomerType" [noAutoComplete]="true" [items]="customerTypes"
                  [optionValueField]="'key'" [optionTextField]="'value'">
                  <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
                    <span>{{option.data.key == '1' ? localService.languageContent.billing.customer :
                      localService.languageContent.billing.biz_customer}}</span>
                  </ng-template>
                </ngx-select>
              </div>
              <div class="col-7">
                <div *ngIf="selectedCustomerType == '1'">
                  <app-business-relationship [id]="elementIds.brn_search_billing_customer" [isMultiCustomerTypes]="true"
                    [businessId]="businessId" [currentUserId]="billedItems.bill.v5"
                    (onUserUpdated)="onUserUpdated($event,1)" [relationShipType]="relationShipType"
                    [relationShipRole]="3" [isInvalidRelationFound]="isInvalidRelationFoundCustomer"
                    (onUserTypeSwitched)="onUserTypeSwitched()"></app-business-relationship>
                </div>
                <div *ngIf="selectedCustomerType == '2'">
                  <app-business-relationship [id]="elementIds.brn_search_billing_customer_business"
                    [isMultiCustomerTypes]="true" [businessId]="businessId" [currentUserId]="billedItems.bill.v13"
                    (onUserUpdated)="onUserUpdated($event,3)" [relationShipType]="relationShipType"
                    [relationShipRole]="4" [isInvalidRelationFound]="isInvalidRelationFoundForBusiness"
                    [isCustomerAsBusiness]="true"
                    (onUserTypeSwitched)="onUserTypeSwitched()"></app-business-relationship>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="row">
              <div class="col-4 label_right">
                <app-label [Text]="localService.languageContent.billing.currently_with" [isWrap]="true"></app-label>
              </div>
              <div class="col-8">
                <app-business-relationship [businessId]="businessId" [currentUserId]="billedItems.bill.v6"
                  (onUserUpdated)="onUserUpdated($event,2)" [relationShipType]="relationShipType"
                  [isReadOnly]="interactionType == 1 || billedItems.status == BillingStatus.Delivered"
                  [relationShipRole]="2"
                  [isInvalidRelationFound]="isInvalidRelationFoundBusiness"></app-business-relationship>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="billingMode == BillingMode.Receipt && isAddOrDeleteProduct">
        <div
          [ngClass]="hasValidBatchDetails && measurmentTypes.length > 0 ? 'col-md-6' : (hasValidBatchDetails || measurmentTypes.length > 0 ? 'col-md-4' : 'col-md-7')"
          style="padding-top: 8px;">
          <span class="arrow_back" style="float:left;margin-top:15px;" (click)="onArrowClick(1)">
            <i
              [ngClass]="isSearchbarShow ? 'material-icons button arrow_up' : 'material-icons button arrow_down'">double_arrow</i>
          </span>
          <div class="billing_search_dd">
            <ngx-select id="{{elementIds.product_dd}}"
              placeholder="{{localService.languageContent.billing.select_product}}"
              title="{{localService.languageContent.billing.select_product}}" (typed)="onSearch($event)"
              [items]="searchItems" [optionValueField]="'key'" [optionTextField]="'v1'" [allowClear]="true"
              [(ngModel)]="wrapper.productId" (remove)="onRemoveProduct()" (select)="onProductSelect()">
              <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
                <div class="row" title="{{option.data.v3}}">
                  <div class="col-12">
                    <span class="en">{{option.data.v2}}&nbsp;-&nbsp;</span>
                    <span [ngClass]="localService.getLanguageCode(option.data.v6)"
                      [ngStyle]="{'color' : option.data.v19 == '0' ? 'red' : 'inherit'}">
                      {{option.data.v3}}
                    </span>
                  </div>
                </div>
              </ng-template>
            </ngx-select>
          </div>
          <div class="billing_search_scan">
            <div style="top: 5px; position: relative;">
              <app-spinner *ngIf="isShowSpinnerCount > 0" style="position: absolute; margin-left: -50px;"></app-spinner>
              <button id="{{elementIds.scanner_camera}}" class="button_icon button_icon_color"
                (click)="isStartCamera = true;">photo_camera</button>
            </div>
          </div>
        </div>
        <div *ngIf="measurmentTypes.length > 0" [ngClass]="hasValidBatchDetails ? 'col-md-2' : 'col-md-3'"
          style="padding-top: 15px;">
          <ngx-select id="{{elementIds.mearsurement_dd}}" [items]="measurmentTypes" [noAutoComplete]="true"
            [optionValueField]="'key'" [optionTextField]="'value'"
            title="{{localService.languageContent.billing.measurement_type}}" [(ngModel)]="selectedMeasurementType"
            (select)="onSelectMeasurementType()"
            placeholder="{{localService.languageContent.billing.measurement_type}}">
            <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
              <span [ngClass]="option.data.isSelected ? 'primary-measurement' : 'child-measurement'">
                {{option.data.value}}
              </span>
            </ng-template>
          </ngx-select>
        </div>
        <div *ngIf="hasValidBatchDetails" [ngClass]="measurmentTypes.length > 0 ? 'col-md-2' : 'col-md-3'"
          style="padding-top: 15px;">
          <ngx-select id="{{elementIds.batch_dd}}" [items]="selectedPrices" [noAutoComplete]="true"
            [optionValueField]="'batchId'" [optionTextField]="'batchTitle'"
            title="{{localService.languageContent.billing.batch_id}}" [(ngModel)]="selectedBatchId"
            placeholder="{{localService.languageContent.billing.batch_id}}" (select)="onSelectBatchId()">
            <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
              <span class="en">{{option.data.batchTitle}}</span>
              <span class="en" style="font-style: italic;"
                *ngIf="isInventoryEnabled && option.data.batchId.length > 3">&nbsp;({{option.data.availableQty}})</span>
            </ng-template>
          </ngx-select>
        </div>
        <div class="col-md-5" [ngStyle]="{'opacity' : selectedPrice ? '1' : '0.5'}">
          <div class="row" style="margin-top:10px;">
            <div class="col-md-7">
              <div class="row">
                <div class="col-6">
                  <span>{{localService.languageContent.billing.price}}</span>
                  <span class="en">&nbsp;:&nbsp;</span>
                  <span class="en" *ngIf="selectedPrice">{{onGetRoundOffSelectedPrice() | number: '1.2-2'}}</span>
                </div>
                <div class="col-6">
                  <span>{{localService.languageContent.billing.min_qty}}</span>
                  <span class="en">&nbsp;:&nbsp;</span>
                  <span class="en" *ngIf="selectedPrice">{{selectedPrice.minQty | number: '1.2-2'}}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-5">
              <div class="row">
                <div class="col-7">
                  <input autocomplete="off" type="number" class="number"
                    (keypress)="localService.isNumberOnly($event,numericConfig)" id="{{elementIds.qty}}"
                    [(ngModel)]="localService.billQty" style="width:100%"
                    (focus)="valueBeforeFocusOut = localService.billQty;"
                    placeholder="*{{localService.languageContent.billing.qty}}{{selectedMeasurement}}"
                    title="*{{localService.languageContent.billing.qty}}{{selectedMeasurement}}"
                    (keydown.enter)="onSaveBilling()" [disabled]="!selectedPrice"
                    [ngClass]="localService.billQty != null ? 'en' : ''" />
                </div>
                <div class="col-5">
                  <button class="btn btn-primary" style="width:100%;" (click)="onSaveBilling()"
                    [disabled]="!selectedPrice"
                    id="{{elementIds.btn_add}}">{{localService.languageContent.billing.add}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="custom_rows_body"
      [ngStyle]="{'max-height' : isCompactQuickPick ? '100vh' : (maxBodyHeight + 'px'), 'display' : isCompactQuickPick ? 'contents' : 'block'}">
      <div *ngIf="billingMode == BillingMode.Receipt && billedItems" style="margin-top:15px;">
        <div class="row styled_row" *ngFor="let item of billedItems.products">
          <div class="col-md-7">
            <div class="row">
              <div class="col-12">
                <label style="margin-left: 10px;"
                  *ngIf="interactionType != 1 && !isDisableReturnInBilling && (isAmountPaid() || billedItems.status == BillingStatus.Delivered) && item.details.v7 && item.details.v7 == '0'">
                  <input type="checkbox" [(ngModel)]="item.details.isSelected">
                  <span style="font-size:16px;color:darkslategrey">&nbsp;</span>
                </label>
                <label style="margin-left: 10px;"
                  *ngIf="(isAmountPaid() || billedItems.status == BillingStatus.Delivered) && item.details.v7 && item.details.v7 != '0'">
                  <input type="checkbox" [disabled]="true" [checked]="true">
                  <span style="font-size:16px;color:darkslategrey">&nbsp;</span>
                </label>
                <button class="button_icon" style="top:9px;"
                  [ngStyle]="{'color' : item.details.v14 && item.details.v14.trim().length > 0 ? 'red' : '#008CBA'}"
                  title="{{localService.languageContent.billing.notes}}" (click)="onOpenProductNotes(item.details.key)">
                  sticky_note_2
                </button>
                <button class="button_icon" style="top:9px;color:#008CBA !important"
                  title="{{localService.languageContent.billing.notes}}" (click)="onOpenStaff(item.details.key)">
                  assignment_ind
                </button>
                <span class="button en"
                  (click)="localService.showSummary(item.productId, 3)">{{item.details.v2}}&nbsp;-&nbsp;</span>
                <span class="{{localService.getLanguageCode(item.details.v6)}}"
                  [ngStyle]="{'color' : isMinimumQtyAvailable(item.productId,item.details.v15) ? '' : 'red'}">{{item.details.v3}}</span>
                <span *ngIf="item.details.v15 && item.details.v15.length > 1" class="en"
                  style="font-style:italic">&nbsp;({{item.details.v16}})</span>
                <span class="en" *ngIf="!isMinimumQtyAvailable(item.productId,item.details.v15)"
                  style="color:red">&nbsp;({{getMinimumQty(item.productId,item.details.v15)}})&nbsp;</span>
                <span *ngIf="item.details.v8 != '-1'">&nbsp;</span>
                <i *ngIf="item.details.v8 != '-1'" class="material-icons button icon_adjust"
                  [ngStyle]="{'color' : item.details.v1 != item.details.v8 ? 'red' : 'green' }"
                  (click)="onSerialNumberMapping(item.productId,item.details.v1,item.details.v15)">numbers</i>
                <span *ngIf="item.details.v8 != '-1'">&nbsp;</span>
              </div>
            </div>
          </div>
          <div class="col-md-5">
            <div class="row">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-6">
                    <div style="display:inline-flex">
                      <div *ngIf="isOverWriteDiscountEnabled">
                        <button class="button_link link_btn" style="margin-top: -3px;"
                          (click)="onEditDiscount(item.details.key)">
                          <span>{{localService.languageContent.billing.discount_short}}</span>
                        </button>
                      </div>
                      <div>
                        <button *ngIf="isOverWritePriceEnabled" class="button_icon price_edit"
                          (click)="onEditPrice(item.details.key)">
                          edit
                        </button>
                        <div [ngClass]="isOverWritePriceEnabled ? 'overwrite_price_active' : ''"
                          *ngIf="selectedProductIdToUpdatePrice != item.productId">
                          <span class="en">(
                            <span class="en" [innerHTML]="currencyIcon + '&nbsp;'"></span>
                            <span
                              [ngClass]="item.details.v17 == '1' ? 'price_edit_on' : 'price_edit_off'">{{item.details.v25
                              | number: '1.2-2'}}</span>
                            &nbsp;/&nbsp;</span>
                          <span>{{onGetName(3,item.details.v5)}}</span>
                          <span class="en">)&nbsp;*&nbsp;</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row">
                      <div class="col-6" style="text-align:right;">
                        <i *ngIf="isAddOrDeleteProduct" class="material-icons delete_icon action_icon"
                          (click)="onRemoveProduct(item.productId,item.details.v15,item.details.v5)">cancel</i>
                        <span *ngIf="!isAddOrDeleteProduct" class="en"
                          title="*{{localService.languageContent.billing.qty}}">
                          {{item.details.v1 | number: '1.2-2'}}
                        </span>
                        <input autocomplete="off" *ngIf="isAddOrDeleteProduct"
                          id="{{elementIds.qty}}_{{item.productId}}_{{item.details.v5}}" type="number"
                          class="number billed_qty" (keypress)="localService.isNumberOnly($event,numericConfig)"
                          [ngClass]="item.details.v1 != null ? 'en' : ''" [(ngModel)]="item.details.v1"
                          placeholder="*{{localService.languageContent.billing.qty}}"
                          title="*{{localService.languageContent.billing.qty}}"
                          (focus)="valueBeforeFocusOut = item.details.v1;"
                          (keydown.enter)="onUpdateQty(item.productId,item.details.v1,item.details.v15,item.details.v5,true)"
                          (focusout)="onUpdateQty(item.productId,item.details.v1,item.details.v15,item.details.v5,false)" />
                      </div>
                      <div class="col-6" style="text-align:right">
                        <span class="en" [innerHTML]="currencyIcon + '&nbsp;'"></span>
                        <span class="en">{{(item.details.v1 == null ? 0 : (item.details.v1 * item.details.v25)) |
                          number:
                          '1.2-2'}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="billingMode == BillingMode.ShowAll" style="margin-top:15px;">
        <div class="row styled_row" *ngFor="let item of searchItems; index as i">
          <div class="col-md-6">
            <div class="row">
              <div class="col-12">
                <button [disabled]="!item.v12" class="button_icon" style="top:9px;"
                  [ngStyle]="{'color' : item.v14 && item.v14.trim().length > 0 ? 'red' : '#008CBA'}"
                  title="{{localService.languageContent.billing.notes}}" (click)="onOpenProductNotes(item.v12)">
                  sticky_note_2
                </button>
                <button [disabled]="!item.v12" class="button_icon" style="top:9px;color:#008CBA !important"
                  title="{{localService.languageContent.billing.notes}}" (click)="onOpenStaff(item.v12)">
                  assignment_ind
                </button>
                <span class="button en" (click)="localService.showSummary(item.key, 3)">{{item.v2}}</span>
                &nbsp;-&nbsp;
                <span class="{{localService.getLanguageCode(item.v6)}}"
                  [ngClass]="isReturned(item.key,item.v15) ? 'returned' : ''">{{item.v3}}</span>
                <span *ngIf="item.v8 != '-1'">&nbsp;</span>
                <i *ngIf="item.v8 != '-1'" class="material-icons button icon_adjust"
                  [ngStyle]="{'color' : item.v1 != item.v8 ? 'red' : 'green' }"
                  (click)="onSerialNumberMapping(item.key,item.v1,item.v15)">numbers</i>
                <span *ngIf="item.v8 != '-1'">&nbsp;</span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-3" style="text-align:right;" *ngIf="!isAddOrDeleteProduct">
                <span class="en" title="*{{localService.languageContent.billing.qty}}">
                  {{billedItems.products | getValue:'key':item.key:'v1'}}
                </span>
              </div>
              <div class="col-3" *ngIf="isAddOrDeleteProduct">
                <i class="material-icons delete_icon action_icon"
                  *ngIf="isAddOrDeleteProduct && billedItems.products | isExists:'productId':item.key"
                  (click)="onRemoveProduct(item.key,item.v15,item.v5)">cancel</i>
                <input id="prd_{{item.key}}" autocomplete="off" type="number" class="number billed_qty"
                  (keypress)="localService.isNumberOnly($event,numericConfig)" [ngClass]="item.v1 != null ? 'en' : ''"
                  [(ngModel)]="item.v1" placeholder="*{{localService.languageContent.billing.qty}}"
                  title="*{{localService.languageContent.billing.qty}}"
                  (keydown.enter)="onAdjustQuickQty(3,item.key,item.v1,item.v15,item.v5,i,true)"
                  (focusout)="onAdjustQuickQty(3,item.key,item.v1,item.v15,item.v5)" />
              </div>
              <div class="col-6">
                <span class="en">&nbsp;*&nbsp;(
                  <span class="en" [innerHTML]="currencyIcon + '&nbsp;'"></span>
                  {{item.v4 | number: '1.2-2'}}&nbsp;/&nbsp;</span>
                <span>{{onGetName(3,item.v5)}}</span>
                <span class="en">)&nbsp;</span>
              </div>
              <div class="col-3 en" style="text-align:right">
                <span class="en" [innerHTML]="currencyIcon + '&nbsp;'"></span>
                <span class="en">{{(item.v1 == null ? 0 : (item.v1 * item.v4)) | number: '1.2-2'}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="billingMode == BillingMode.QuickPick" style="width:calc(100% - 10px)"
        [ngStyle]="{'margin-top' : isCompactQuickPick ? '0px' : '15px'}"
        [ngClass]="isCompactQuickPick ? 'center' : 'banner center'">
        <div *ngIf="isCompactQuickPick">
          <div *ngIf="interactionType == InteractionType.User && !isAmountPaid()" class="banner center freeze_height"
            style="text-align: center;color: maroon;font-size: large;">
            {{localService.languageContent.billing.order_submitted}}
          </div>
          <div class=" banner compact_quick_pick_header" *ngIf="interactionType != InteractionType.User">
            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-3">
                    <div class="wrap-div">
                      <button class="btn btn-primary" style="width:100%"
                        [disabled]="!(billingId && billingId != '' && billingId != '0' && isActiveProductAvailable)"
                        (click)="onRoute(1)">
                        <i class="material-icons add_icon_quick_pick">add_circle_outline</i>
                        <span>{{localService.languageContent.billing.new}}</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="wrap-div">
                      <button class="btn btn-primary" style="width:100%" [disabled]="!(tableId && tableId.length > 5)"
                        (click)="onRoute(4)">
                        <i class="material-icons add_icon_quick_pick">airline_seat_recline_normal</i>
                        <span>{{localService.languageContent.billing.seat}}</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-6">
                    <button id="{{elementIds.scanner_camera}}" class="button_icon button_icon_color"
                      (click)="isStartCamera = true;" style="top: 5px;">photo_camera</button>
                    <input autocomplete="off" type="text"
                      style="bottom: -7px;position: relative; width: calc(100% - 50px);" [(ngModel)]="quickSearchKey"
                      title="{{localService.languageContent.common.search}}" id="{{elementIds.txt_quick_search}}"
                      placeholder="{{localService.languageContent.common.search}}" />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row" *ngIf="isAddOrDeleteProduct">
                  <div class="col-1" style="text-align: center;"
                    *ngIf="(interactionType == 2 || interactionType == 4) && isFooterbarShow && billingId != '0' && isBusinessOptionVisible(23)">
                    <button class="button_icon footer_icon" (click)="onRoute(6)"
                      title="{{localService.languageContent.billing.custom_label_print}}">
                      new_label
                    </button>
                  </div>
                  <div
                    [ngClass]="(interactionType == 2 || interactionType == 4) && isFooterbarShow && billingId != '0' && isBusinessOptionVisible(23) ? 'col-5' : 'col-6'">
                    <ngx-select style="top: 4px; position: relative;" [(ngModel)]="selectedCategory"
                      [noAutoComplete]="true" [items]="productCategories" [optionValueField]="'key'"
                      [optionTextField]="'v1'">
                    </ngx-select>
                  </div>
                  <div class="col-6">
                    <label style="font-weight: normal; margin-left: 10px;">
                      <input type="checkbox" [(ngModel)]="isShowSelected" />
                      <span>&nbsp;{{ (billedItems && billedItems.products ? billedItems.products.length : '0') + ' - ' +
                        localService.languageContent.billing.selected}}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="banner compact_quick_pick_mode_container" style="max-height: calc(100vh - 240px);margin-top:5px"
            *ngIf="searchItems">
            <ng-container *ngFor="let item of searchItems">
              <div class="compact_quick_pick_mode"
                [ngClass]="{'compact_quick_pick_mode_with_img': isShowQuickPickImage && item.images.length > 0}"
                *ngIf="((selectedCategory == '0' && !isShowSelected) || (item.values && item.values.includes(selectedCategory) && !isShowSelected) || ((selectedCategory == '1' || isShowSelected) && (billedItems.products | isExists:'productId':item.key))) && (!quickSearchKey || quickSearchKey.length == 0 || item.v16.indexOf(quickSearchKey.toLowerCase()) > -1)">
                <div [ngClass]="{'quick_pick_container': isShowQuickPickImage && item.images.length > 0}">
                  <div class="quick_pick_left" *ngIf="isShowQuickPickImage && item.images.length > 0">
                    <div class="picsum-img-wrapper" *ngIf="item.images && item.images.length == 1">
                      <img [src]="item.images[0]" [alt]="item.v1" />
                    </div>
                    <div *ngIf="item.images && item.images.length > 1">
                      <ngb-carousel>
                        <ng-template ngbSlide *ngFor="let image of item.images">
                          <div class="picsum-img-wrapper">
                            <img [src]="image" [alt]="item.v1" />
                          </div>
                        </ng-template>
                      </ngb-carousel>
                    </div>
                  </div>
                  <div [ngClass]="{'quick_pick_right': isShowQuickPickImage && item.images.length > 0}">
                    <div>
                      <div class="wrap-div compact_quick_pick_item">
                        <button [disabled]="!item.v12" class="button_icon" style="top:5px;"
                          [ngStyle]="{'color' : item.v14 && item.v14.trim().length > 0 ? 'red' : '#008CBA'}"
                          title="{{localService.languageContent.billing.notes}}" (click)="onOpenProductNotes(item.v12)">
                          sticky_note_2
                        </button>
                        <span class="en">&nbsp;{{item.v2}}&nbsp;-&nbsp;</span>
                        <span class="en compact_quick_pick_qty_after_paid" *ngIf="isAmountPaid()">&nbsp;({{item.v1 ??
                          '0'}})&nbsp;</span>
                        <span [ngClass]="localService.getLanguageCode(item.v6)">{{item.v3}}</span>
                      </div>
                    </div>
                    <div *ngIf="isAddOrDeleteProduct">
                      <div class="row">
                        <div class="col-6">
                          <button class="button_icon button_icon_color icon_adjust" style="color:red"
                            [disabled]="!item.v1 || item.v1 <= 0 || interactionType == InteractionType.User"
                            (click)="onAdjustQuickQty(1,item.key,item.v1,item.v15,item.v5)">remove_circle_outline</button>
                          <span class="en">&nbsp;{{item.v1 ?? '0'}}</span>
                        </div>
                        <div class="col-6">
                          <div class="wrap-div">
                            <button class="btn btn-primary" style="width:100%"
                              [disabled]="interactionType == InteractionType.User"
                              (click)="onAdjustQuickQty(2,item.key,item.v1,item.v15,item.v5)">
                              <i class="material-icons add_icon_quick_pick">add_circle_outline</i>
                              <span>{{localService.languageContent.common.add}}</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <div class="compact_quick_pick_mode compact_quick_pick_mode_dummy">
              &nbsp;
            </div>
            <div class="compact_quick_pick_mode compact_quick_pick_mode_dummy">
              &nbsp;
            </div>
          </div>
          <div class="compact_quick_pick_footer">
            <div class="banner center" style="max-width: 500px"
              [ngStyle]="{'width' : localService.windowWidth > 900 ? 'calc(100% - 100px)' : 'calc(100% - 50px)'}">
              <div class="row">
                <div [ngClass]="interactionType != InteractionType.User ? 'col-5' : 'col-6'">
                  <div class="wrap-div">
                    <button type="button" class="btn btn-primary" style="width:100%" (click)="onActionByIndex(1)">
                      <span class="en" style="color:white !important" [innerHTML]="currencyIcon + '&nbsp;'"></span>
                      <span class="en" style="font-size: 20px;">{{ total | number: '1.2-2' }}</span>
                    </button>
                  </div>
                </div>
                <div class="col-5" *ngIf="interactionType != InteractionType.User">
                  <div class="wrap-div" style="text-align: center;">
                    <button class="btn btn-primary" id="{{elementIds.btn_accept}}" style="width: 100%;"
                      *ngIf="isBusinessOptionVisible(7) && isAddOrDeleteProduct && !isAmountPaid()"
                      [disabled]="billingId.length < 5" (click)="onUpdateStatus(BillingStatus.Accepted)">
                      {{(isAllowToModifyOnAcceptedStatus && billingId.length > 5 && !isAmountPaid() &&
                      !(billedItems.status == BillingStatus.Draft ||
                      billedItems.status == BillingStatus.Submitted)) ?
                      localService.languageContent.billing.refresh_live_tokens :
                      localService.languageContent.billing.accept}}
                    </button>
                    <button class="btn btn-primary"
                      *ngIf="!isBusinessOptionVisible(7) && isBusinessOptionVisible(6) && !isAmountPaid()"
                      [disabled]="billingId.length < 5" style="width: 100%;"
                      title="{{localService.languageContent.billing.paid}}" (click)="isOpenPaymentModes = true">
                      {{localService.languageContent.billing.paid}}
                    </button>
                    <button class="btn btn-primary" *ngIf="isAmountPaid()" style="width: 100%;" (click)="onPrint()">
                      {{localService.languageContent.billing.print}}
                    </button>
                  </div>
                </div>
                <div [ngClass]="interactionType != InteractionType.User ? 'col-2' : 'col-6'">
                  <div class="wrap-div" style="text-align: center;">
                    <button class="button_icon button_icon_color" style="top: 5px;" [disabled]="!(billingId.length > 5)"
                      *ngIf="interactionType != InteractionType.User" (click)="onOpenMoreActionForQuickPickCompact()">
                      more_horiz
                    </button>
                    <button class="btn btn-primary" id="{{elementIds.btn_submit}}" style="width:100%;"
                      *ngIf="interactionType == InteractionType.User"
                      [disabled]="billedItems.status != BillingStatus.Draft"
                      (click)="onUpdateStatus(2,true)">{{localService.languageContent.common.submit}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <table *ngIf="!isCompactQuickPick" style="width:100%">
          <tr>
            <td style="width:25%;vertical-align:top">
              <div>
                <button id="{{elementIds.scanner_camera}}" class="button_icon button_icon_color"
                  (click)="isStartCamera = true;" style="top: 5px;">photo_camera</button>
                <input autocomplete="off" type="text" style="margin-bottom: 10px;width: calc(100% - 50px);"
                  [(ngModel)]="quickSearchKey" title="{{localService.languageContent.common.search}}"
                  id="{{elementIds.txt_quick_search}}" placeholder="{{localService.languageContent.common.search}}" />
              </div>
              <div class="quick_pick_tab_section">
                <div class="box" *ngIf="isAddOrDeleteProduct"
                  [ngClass]="selectedCategory == '0' ? 'tab tab_selected' : 'tab'"
                  (click)="onSelectProductCategory('0')">
                  <span>{{localService.languageContent.billing.all_products}}</span>
                </div>
                <div class="box"
                  [ngClass]="selectedCategory == '1' || (selectedCategory == '0' && !isAddOrDeleteProduct) ? 'tab tab_selected' : 'tab'"
                  (click)="onSelectProductCategory('1')">
                  <span>{{localService.languageContent.billing.selected_products}}</span>
                </div>
                <div *ngIf="productCategories">
                  <div *ngFor="let item of productCategories" class="box"
                    [ngClass]="selectedCategory == item.key ? 'tab tab_selected' : 'tab'"
                    (click)="onSelectProductCategory(item.key)">
                    <span [ngClass]="localService.getLanguageCode(item.v2)">{{item.v1}}</span>
                  </div>
                </div>
              </div>
            </td>
            <td style="width: 75%; vertical-align: top">
              <div *ngIf="searchItems" class="row">
                <div *ngFor="let item of searchItems"
                  [ngClass]="((billedItems.products | isExists:'productId':item.key) ? 'quick_pick_selected quick_pick ' : 'quick_pick ') + ((selectedCategory == '0' || (item.values && item.values.includes(selectedCategory)) || (selectedCategory == '1' && (billedItems.products | isExists:'productId':item.key))) && (!quickSearchKey || quickSearchKey.length == 0 || item.v16.indexOf(quickSearchKey.toLowerCase()) > -1) ? (isShowQuickPickImage && item.images.length > 0 ? 'col-sm-3' : 'col-sm-2') +' box' : 'no_quick_pick')">
                  <div
                    *ngIf="(!quickSearchKey || quickSearchKey.length == 0 || item.v16.indexOf(quickSearchKey.toLowerCase()) > -1)">
                    <div [ngClass]="{'quick_pick_container': isShowQuickPickImage && item.images.length > 0}">
                      <div class="quick_pick_left" *ngIf="isShowQuickPickImage && item.images.length > 0">
                        <div class="picsum-img-wrapper" *ngIf="item.images && item.images.length == 1">
                          <img [src]="item.images[0]" [alt]="item.v1" />
                        </div>
                        <div *ngIf="item.images && item.images.length > 1">
                          <ngb-carousel>
                            <ng-template ngbSlide *ngFor="let image of item.images">
                              <div class="picsum-img-wrapper">
                                <img [src]="image" [alt]="item.v1" />
                              </div>
                            </ng-template>
                          </ngb-carousel>
                        </div>
                      </div>
                      <div [ngClass]="{'quick_pick_right': isShowQuickPickImage && item.images.length > 0}">
                        <div
                          *ngIf="(selectedCategory == '0' || (item.values && item.values.includes(selectedCategory)) || (selectedCategory == '1' && (billedItems.products | isExists:'productId':item.key)))">
                          <button [disabled]="!item.v12" class="button_icon" style="top:9px;"
                            [ngStyle]="{'color' : item.v14 && item.v14.trim().length > 0 ? 'red' : '#008CBA'}"
                            title="{{localService.languageContent.billing.notes}}"
                            (click)="onOpenProductNotes(item.v12)">
                            sticky_note_2
                          </button>
                          <span class="{{localService.getLanguageCode(item.v6)}}"
                            [ngClass]="isReturned(item.key,item.v15) ? 'returned' : ''">{{item.v3}}</span>
                          <span *ngIf="item.v8 != '-1'">&nbsp;</span>
                          <i *ngIf="item.v8 != '-1'" class="material-icons button icon_adjust"
                            [ngStyle]="{'color' : item.v1 != item.v8 ? 'red' : 'green' }"
                            (click)="onSerialNumberMapping(item.key,item.v1,item.v15)">numbers</i>
                          <span *ngIf="item.v8 != '-1'">&nbsp;</span>
                        </div>
                        <div class="quick_pick_price"
                          *ngIf="selectedCategory == '0' || (item.values && item.values.includes(selectedCategory)) || (selectedCategory == '1' && (billedItems.products | isExists:'productId':item.key))">
                          <span class="en" [innerHTML]="currencyIcon + '&nbsp;'"></span>
                          <span class="button en quick_pick_prd_info"
                            (click)="localService.showSummary(item.key, 3)">{{item.v2}}&nbsp;</span>
                          <span class="en">{{item.v4 | number: '1.2-2'}}&nbsp;/&nbsp;</span>
                          <span>{{onGetName(3,item.v5)}}</span>
                        </div>
                        <div class="en" *ngIf="!isAddOrDeleteProduct">
                          <div style="float:left;">
                            <span>{{item.v1 == null ? 0 : item.v1 | number: '1.2-2'}}</span>
                          </div>
                          <div style="float:right;">
                            <span class="en" [innerHTML]="currencyIcon + '&nbsp;'"></span>
                            <span>{{(item.v1 == null ? 0 : (item.v1 * item.v4)) | number: '1.2-2'}}</span>
                          </div>
                        </div>
                        <div
                          *ngIf="isAddOrDeleteProduct && (selectedCategory == '0' || (item.values && item.values.includes(selectedCategory)) || (selectedCategory == '1' && (billedItems.products | isExists:'productId':item.key)))">
                          <button class="button_icon button_icon_color icon_adjust" style="color:red"
                            [disabled]="!item.v1 || item.v1 <= 0"
                            (click)="onAdjustQuickQty(1,item.key,item.v1,item.v15,item.v5)">remove_circle_outline</button>
                          <input autocomplete="off" type="number" class="number quick_pick_qty"
                            (keypress)="localService.isNumberOnly($event,numericConfig)" min="1"
                            [ngClass]="item.v1 ? 'en' : ''" [(ngModel)]="item.v1"
                            placeholder="*{{localService.languageContent.billing.qty}}"
                            title="*{{localService.languageContent.billing.qty}}"
                            (keydown.enter)="onAdjustQuickQty(3,item.key,item.v1,item.v15,item.v5)"
                            (focusout)="onAdjustQuickQty(3,item.key,item.v1,item.v15,item.v5)" />
                          <button class="button_icon button_icon_color icon_adjust" style="color:darkgreen"
                            (click)="onAdjustQuickQty(2,item.key,item.v1,item.v15,item.v5)">add_circle_outline</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div
      *ngIf="!isCompactQuickPick &&(interactionType == 2 || interactionType == 4) && billedItems && billedItems.isActionsAllowed && localService.windowWidth > 900"
      class="footer_add_new" [ngStyle]="{'top' : 'calc(100% - '+ localService.getTopForAddNew() +'px'}">
      <button class="button_icon footer_add_copy_bill"
        *ngIf="billingId && billingId != '' && billingId != '0' && isActiveProductAvailable" (click)="onRoute(1)">
        add_circle_outline
      </button>
      <button class="button_icon footer_add_copy_bill"
        *ngIf="billingId && billingId != '' && billingId != '0' && isActiveProductAvailable" (click)="onRoute(2)">
        content_copy
      </button>
      <div style="float:left;margin-top:-25px;margin-left:15px;">
        <app-search-token [currentId]="billingId" [businessId]="businessId"></app-search-token>
      </div>
    </div>
    <div class="footer freeze_height"
      *ngIf="!isCompactQuickPick && billedItems && billedItems.isActionsAllowed && billedItems.products.length > 0 && billedItems.status != BillingStatus.None && billedItems.status != BillingStatus.Cancelled && billedItems.status != BillingStatus.Rejected">
      <span class="arrow_back" style="float:left;" (click)="onArrowClick(2)">
        <i class="material-icons" style="margin-top:5px;"
          [ngClass]="isFooterbarShow ? 'button arrow_right' : 'button arrow_left'">double_arrow</i>
      </span>
      <button class="button_icon button_icon_color " style="top: 5px; left: 5px;" *ngIf="isSeatingElligible()"
        (click)="onOpenSeatArrangements()">airline_seat_recline_normal</button>
      <button class="button_icon button_icon_color" style="float:left;top: 8px;" *ngIf="tableId && tableId.length > 5"
        (click)="onRoute(4)">
        airline_seat_recline_normal
      </button>
      <button style="float:left;top: 8px;" [disabled]="billingId == '0'" *ngIf="!(tableId && tableId.length > 5)"
        class="button_icon button_icon_color " (click)="onGenerateBarCode()">qr_code_scanner</button>
      <button style="float:left;top: 8px;" *ngIf="isAmountPaid()" class="button_icon button_icon_color "
        (click)="isOpenPaymentModes = true">credit_card</button>
      <span *ngIf="isBusinessOptionVisible(11) && isAddOrDeleteProduct" class="en">&nbsp;+</span>
      <input autocomplete="off" type="number" class="number"
        (keypress)="localService.isNumberOnly($event,numericConfigRoundoff)"
        [ngClass]="isRoundoffFocused ? 'round_focused' : 'round_unfocused'"
        *ngIf="isBusinessOptionVisible(11) && isAddOrDeleteProduct" [(ngModel)]="txtAdjustment"
        (focus)="isRoundoffFocused = true;" (blur)="isRoundoffFocused = false;onAction(15,txtAdjustment);"
        (input)="onTotal(true)" title="{{localService.languageContent.billing.adjustment}}"
        placeholder="{{localService.languageContent.billing.adjustment}}" />

      <span *ngIf="isBusinessOptionVisible(12) && isAddOrDeleteProduct" class="en">&nbsp;-</span>
      <input autocomplete="off" type="number" class="number"
        (keypress)="onConvertDiscountFromPercentage($event); localService.isNumberOnly($event,numericConfigRoundoff);"
        [ngClass]="isDiscountFocused ? 'round_focused' : 'round_unfocused'"
        *ngIf="isBusinessOptionVisible(12) && isAddOrDeleteProduct" [(ngModel)]="txtDiscount"
        (focus)="isDiscountFocused = true;" (blur)="isDiscountFocused = false;onAction(17,txtDiscount);"
        (input)="onTotal()" title="{{localService.languageContent.billing.discount_amount}}"
        placeholder="{{localService.languageContent.billing.discount_amount}}" />

      <button type="button" class="btn btn-primary" (click)="onActionByIndex(1)">
        <span class="en" style="color:white !important" [innerHTML]="currencyIcon + '&nbsp;'"></span>
        <span class="en" style="font-size: 20px;">{{ total | number: '1.2-2' }}</span>
      </button>

      <textarea id="{{elementIds.txt_notes}}" rows="5" [(ngModel)]="billedItems.bill.v9" *ngIf="isShowNotes"
        title="{{localService.languageContent.billing.notes}}" (blur)="onAction(8,billedItems.bill.v9)"
        placeholder="{{localService.languageContent.billing.notes}}"></textarea>
      <button class="button_icon button_icon_color footer_icon" style="top:9px;"
        *ngIf="isFooterbarShow && interactionType != 1 && billedItems.bill.v4 == '0'"
        title="{{localService.languageContent.billing.notes}}" (click)="onShowHideButton(1)">
        speaker_notes
      </button>
      <button class="btn btn-primary"
        *ngIf="isBusinessOptionVisible(6) && isFooterbarShow && initialization.paymentMethods && initialization.paymentMethods.length > 0 && billedItems.status != 11 && billedItems.bill.v4 == '0'"
        style="z-index:1" title="{{localService.languageContent.billing.paid}}" (click)="isOpenPaymentModes = true">
        {{localService.languageContent.billing.paid}}
      </button>

      <button class="btn btn-primary" id="{{elementIds.btn_submit}}"
        *ngIf="isFooterbarShow && interactionType == 1 && billedItems.status == BillingStatus.Draft"
        (click)="onUpdateStatus(BillingStatus.Submitted)">{{localService.languageContent.common.submit}}</button>
      <button class="btn btn-primary" id="{{elementIds.btn_accept}}"
        *ngIf="isBusinessOptionVisible(7) && isFooterbarShow && interactionType != 1 && (billedItems.status == BillingStatus.Draft || billedItems.status == BillingStatus.Submitted || isAddOrDeleteProduct) && billingId.length > 5"
        (click)="onUpdateStatus(BillingStatus.Accepted)">
        {{ (isAllowToModifyOnAcceptedStatus && billingId.length > 5 && !isAmountPaid() && !(billedItems.status ==
        BillingStatus.Draft || billedItems.status
        == BillingStatus.Submitted)) ?
        localService.languageContent.billing.refresh_live_tokens :
        localService.languageContent.billing.accept}}
      </button>
      <button class="btn btn-primary"
        *ngIf="isFooterbarShow && interactionType != 1 && billedItems.bill.v11 == '1' && (billedItems.status == BillingStatus.Draft || billedItems.status == BillingStatus.Submitted)"
        (click)="onUpdateStatus(BillingStatus.Rejected)">{{localService.languageContent.billing.reject}}</button>
      <button class="btn btn-primary"
        *ngIf="isBusinessOptionVisible(8) && isFooterbarShow && interactionType != 1 && (billedItems.status == BillingStatus.Draft || billedItems.status == BillingStatus.Submitted || billedItems.status == BillingStatus.Accepted)"
        (click)="onUpdateStatus(BillingStatus.Ready)">{{localService.languageContent.billing.ready}}</button>

      <ngx-select *ngIf="interactionType == 2" id="{{elementIds.dd_delivery_method}}" [isFocused]="true"
        [(ngModel)]="billedItems.bill.v8" [noAutoComplete]="true" [items]="initialization.deliveryTypes"
        [optionValueField]="'key'" [optionTextField]="'value'"
        [ngClass]="isDropDownInFooter == 3 ? 'footer_dropdown_on' : 'footer_dropdown_off'"
        (close)="onShowHideDropDown(3,true)" (select)="onAction(10,billedItems.bill.v8)">
      </ngx-select>
      <button class="button_icon button_icon_color footer_icon" id="{{elementIds.delivery_method}}"
        *ngIf="interactionType == 2 && isFooterbarShow && billingId != '0' &&  billedItems.status != BillingStatus.Delivered"
        title="{{localService.languageContent.billing.delivery_method}}" (click)="onShowHideDropDown(3)">
        delivery_dining
      </button>
      <button class="btn btn-primary"
        *ngIf="isBusinessOptionVisible(9) && isFooterbarShow && interactionType != 1 && (billedItems.status == BillingStatus.Draft || billedItems.status == BillingStatus.Submitted || billedItems.status == BillingStatus.Accepted || billedItems.status == BillingStatus.Ready)"
        (click)="onUpdateStatus(BillingStatus.OutForDeliver)">{{localService.languageContent.billing.out_for_deliver}}</button>
      <button class="btn btn-primary"
        *ngIf="isBusinessOptionVisible(10) && isFooterbarShow && interactionType != 1 && (billedItems.status == BillingStatus.Draft ||billedItems.status == BillingStatus.Submitted || billedItems.status == BillingStatus.Accepted || billedItems.status == BillingStatus.Ready || billedItems.status == BillingStatus.OutForDeliver)"
        (click)="onUpdateStatus(BillingStatus.Delivered)">{{localService.languageContent.billing.delivered}}</button>
      <button class="btn btn-primary" *ngIf="isFooterbarShow && interactionType != 1 && isProductAvailableForReturn()"
        (click)="onShowReturnedItems(false)">{{localService.languageContent.billing.return}}</button>
      <button class="button_icon button_icon_color " style="top:7px;" *ngIf="isFooterbarShow && isReturnAvailable()"
        (click)="onShowReturnedItems(true)">repartition</button>
      <ngx-select *ngIf="interactionType == 2" id="{{elementIds.dd_print_language}}" [isFocused]="true"
        [(ngModel)]="printingLanguage" [noAutoComplete]="true" [items]="localService.languagesEquivalent"
        [optionValueField]="'v1'" [optionTextField]="'v3'"
        [ngClass]="isDropDownInFooter == 2 ? 'footer_dropdown_on' : 'footer_dropdown_off'"
        (close)="onShowHideDropDown(2,true)">
      </ngx-select>
      <button class="button_icon button_icon_color footer_icon" id="{{elementIds.print_language}}"
        *ngIf="(interactionType == 2 || interactionType == 4) && isFooterbarShow && billingId != '0' && !isBusinessOptionVisible(19)"
        title="{{localService.languageContent.billing.print_lang}}" (click)="onShowHideDropDown(2)">
        translate
      </button>
      <button class="button_icon footer_icon" (click)="onRoute(6)"
        *ngIf="(interactionType == 2 || interactionType == 4) && isFooterbarShow && billingId != '0' && isBusinessOptionVisible(23)"
        title="{{localService.languageContent.billing.custom_label_print}}">
        new_label
      </button>
      <button class="button_icon button_icon_color footer_icon"
        *ngIf="!(isViewMode && isDisablePrintInViewMode) &&(interactionType == 2 || interactionType == 4) && isFooterbarShow && billingId != '0' && isShowSendToPhone && (!isDisablePrintOnDraftMode || (isDisablePrintOnDraftMode && billedItems.status != BillingStatus.Draft))"
        title="{{localService.languageContent.common.send_to_phone}}" (click)="onSendToPhone(true)">
        send_to_mobile
      </button>
      <button class="button_icon footer_icon"
        *ngIf="!(isViewMode && isDisablePrintInViewMode) &&(interactionType == 2 || interactionType == 4) && isFooterbarShow && billingId != '0' && !isBusinessOptionVisible(19) && (!isDisablePrintOnDraftMode || (isDisablePrintOnDraftMode && billedItems.status != BillingStatus.Draft))"
        title="{{localService.languageContent.billing.print}}" (click)="onPrint()"
        [ngStyle]="{'color': isLocalPrintersAvailable ? 'red' : '#008CBA'}">
        print
      </button>
      <button class="button_icon button_icon_color footer_icon"
        title="{{localService.languageContent.billing.more_details}}" (click)="onShowHideButton(2)">
        more
      </button>
    </div>
    <div class="footer freeze_height"
      *ngIf="!isCompactQuickPick && interactionType != 1 && billedItems && !billedItems.isActionsAllowed && billedItems.products.length > 0 && billedItems.status != BillingStatus.None && billedItems.status != BillingStatus.Cancelled && billedItems.status != BillingStatus.Rejected">
      <span
        style="top: -3px; position: relative;">&nbsp;{{localService.languageContent.billing.unavailable}}&nbsp;</span>
      <ngx-select id="{{elementIds.dd_print_language}}" [isFocused]="true" [(ngModel)]="printingLanguage"
        [noAutoComplete]="true" [items]="localService.languagesEquivalent" [optionValueField]="'v1'"
        [optionTextField]="'v3'" [ngClass]="isDropDownInFooter == 2 ? 'footer_dropdown_on' : 'footer_dropdown_off'"
        (close)="onShowHideDropDown(2,true)">
      </ngx-select>
      <button class="button_icon button_icon_color footer_icon" id="{{elementIds.print_language}}"
        *ngIf="isFooterbarShow && billingId != '0' && !isBusinessOptionVisible(19)"
        title="{{localService.languageContent.billing.print_lang}}" (click)="onShowHideDropDown(2)">
        translate
      </button>
      <button class="button_icon button_icon_color footer_icon"
        *ngIf="!(isViewMode && isDisablePrintInViewMode) && isFooterbarShow && billingId != '0' && !isBusinessOptionVisible(19) && (!isDisablePrintOnDraftMode || (isDisablePrintOnDraftMode && billedItems.status != BillingStatus.Draft))"
        title="{{localService.languageContent.billing.print}}" (click)="onPrint()">
        print
      </button>
      <button class="button_icon button_icon_color footer_icon"
        *ngIf="!(isViewMode && isDisablePrintInViewMode) && isFooterbarShow && billingId != '0' && isShowSendToPhone && (!isDisablePrintOnDraftMode || (isDisablePrintOnDraftMode && billedItems.status != BillingStatus.Draft))"
        title="{{localService.languageContent.billing.print}}" (click)="onShowHideButton(2)">
        send_to_mobile
      </button>
      <button class="button_icon button_icon_color footer_icon"
        title="{{localService.languageContent.billing.more_details}}" (click)="onShowHideButton(2)">
        more
      </button>
    </div>
    <div class="banner footer_summary" *ngIf="isShowSummary">
      <div>
        <button style="color:red;top:-10px;" class="button_icon button_icon_color "
          title="{{localService.languageContent.billing.show_deleted_items}}" (click)="onGetDeletedItems()"
          [disabled]="billingId == '0'">history</button>
        <span class="en button" style="margin-left: 10px; top: -17px; position: relative;"
          (click)="localService.showSummary(businessId,2)">{{billedItems.bill.v2}}&nbsp;</span>
        <i class="material-icons" style="top: -10px; position: relative;" (click)="onLoad()">replay_circle_filled</i>
        <button style="color:red;top:-10px;" class="button_icon button_icon_color " *ngIf="isDedicatedStorageAvailable"
          title="{{localService.languageContent.billing.attach_files}}" (click)="onRoute(5)"
          [disabled]="billingId == '0'">attach_file</button>
        <i class="material-icons" style="transform: rotate(45deg);color: palevioletred;font-size: 25px;float:right;"
          (click)="onShowHideButton(2)" title="{{localService.languageContent.common.close}}">add_circle_outline</i>
      </div>
      <div style="margin-top: -20px;">
        <label>{{localService.languageContent.billing.notes}}&nbsp;:&nbsp;</label>
      </div>
      <div>
        {{billedItems.bill.v9}}
      </div>
      <div>
        <label>{{localService.languageContent.billing.payment_mode}}&nbsp;:&nbsp;</label>
        <span>{{onGetName(1)}}</span>
      </div>
      <div>
        <label>{{localService.languageContent.billing.delivery_method}}&nbsp;:&nbsp;</label>
        <span>{{onGetName(2)}}</span>
      </div>
      <div *ngIf="billedItems.bill.v8 == '5'">
        <label>{{localService.languageContent.billing.appointment_details}}&nbsp;:&nbsp;</label>
        <span *ngIf="billedItems.bill.v14 == '0'">{{localService.languageContent.billing.not_found}}</span>
        <button class="button_icon button_icon_color " *ngIf="billedItems.bill.v14 == '0'" style="left:10px;"
          (click)="onCheckAppointmentType()">
          add_circle_outline
        </button>
        <span *ngIf="billedItems.bill.v14 != '0'" class="en">{{billedItems.bill.v15}}</span>
        <span>&nbsp;&nbsp;</span>
        <button class="button_icon button_icon_color " *ngIf="billedItems.bill.v14 != '0'"
          (click)="onCheckAppointmentType(true)">
          {{interactionType != 1 ? 'edit_calendar' : 'preview'}}
        </button>
      </div>
      <div *ngIf="billedItems.bill.v8 == '2'">
        <label>{{localService.languageContent.billing.delivery_address}}&nbsp;:&nbsp;</label>
        <span
          *ngIf="billedItems.bill.v10 == '0' && billedItems.bill.v13 == ''">{{localService.languageContent.billing.not_found}}</span>
        <button class="button_icon button_icon_color " *ngIf="billedItems.bill.v10 == '0' && billedItems.bill.v13 == ''"
          style="left:10px;" (click)="onOpenDeliveryAddress()">
          add_circle_outline
        </button>
        <button class="button_icon button_icon_color "
          *ngIf="interactionType != 1 && billedItems.bill.v10 != '0' && billedItems.bill.v13 == ''" style="top:10px;"
          (click)="onOpenDeliveryAddress(billedItems.bill.v10)">
          edit
        </button>
        <span>&nbsp;&nbsp;</span>
        <i class="material-icons delete_icon action_icon delete_address"
          *ngIf="interactionType != 1 && billedItems.bill.v10 != '0' && billedItems.bill.v13 == ''" style="top:10px;"
          (click)="onAction(13)">cancel</i>
        <div *ngIf="billedItems.bill.v10 != '0' || billedItems.bill.v13 != ''"
          [ngClass]="localService.getLanguageCode(billedItems.bill.v16)">{{billedItems.bill.v17}}</div>
      </div>
    </div>
  </div>
  <app-print-receipt *ngIf="isPrint" [receiptId]="billingId" [IsPrint]="isPrint" [isForBusiness]="true"
    (onPrinted)="onPrinted()" [printingLanguageId]="printingLanguage" [businessId]="businessId"
    [interactionType]="interactionType" />
  <app-text-update *ngIf="isOpenUpdateProductNote" [(isOpen)]="isOpenUpdateProductNote" [key]="selectedBillingDetailId"
    (onSave)="onUpdateProductNotes($event)" [placeHolder]="localService.languageContent.billing.notes"
    [header]="productNoteHeader" [value]="productNoteDescription" [isReadOnly]="!(billedItems.bill.v4 == '0')" />
  <app-bill-staff *ngIf="isOpenUpdateStaff" [(isOpen)]="isOpenUpdateStaff" [key]="selectedBillingDetailId"
    (onSave)="onUpdateStaff($event)" [businessId]="businessId"
    [placeHolder]="localService.languageContent.billing.staff" [header]="productNoteHeader"
    [createdByName]="createdByName" [createdByLanguage]="createdByLanguage" [staffId]="staffId"
    [isReadOnly]="!(billedItems.bill.v4 == '0')" />
</div>
<div *ngIf="businessId && businessId != '0'">
  <app-bill-taxes [(isOpenPopup)]="isBillTaxesPopupOpen" [billedItems]="billedItems"
    (onClose)="onClosesBillTaxesPopup($event)" />
</div>

<app-qr-scanner (onQrScanned)="onQrScanned($event)" [(isStart)]="isStartCamera" />
<div *ngIf="billingId && billingId.length > 5 && initialization">
  <app-payment-qr-image [businessId]="businessId" [amount]="total" [amountInputId]="elementIds.amount"
    [supportingId]="billingId" [(isGenerateQr)]="isGenerateQr" [qrType]="wrapper.QrType"
    [supportingType]="SupportingType.Billing" (onPaymentProccesed)="onPaymentProccesed($event)" />
  <app-bill-payment-types [(isOpenPopup)]="isOpenPaymentModes" [paymentMethods]="initialization.paymentMethods"
    [billAmount]="total" [businessId]="businessId" [selectedPaymentMode]="billedItems.bill.v7"
    (onSelected)="onSelectedPaymentMode($event)" [receiptId]="billingId" [isPaid]="isAmountPaid()"
    (onPaid)="onPaid($event)" [isShowPayAndPrint]="isPrintOncePaid" [isShowPayAndSendToPhone]="isShowSendToPhone" />
  <app-overwrite-price *ngIf="isOpenOwerwritePrice" [(isOpenPopup)]="isOpenOwerwritePrice" [businessId]="businessId"
    [billingDetailId]="selectedBillingDetailId" [selectedQty]="selectedQty" [currentPrice]="currentPrice"
    [isNotConsiderTax]="isNotConsiderTax" [businessTaxes]="billedItems.businessTaxes"
    (onCompleted)="onUpdatePrice($event)" [billingValidation]="billingValidation" />
  <app-overwrite-discount *ngIf="isOpenOwerwriteDiscount" [(isOpenPopup)]="isOpenOwerwriteDiscount"
    [billingDetailId]="selectedBillingDetailId" (onCompleted)="onUpdateDiscount($event)" [baseAmount]="currentPrice"
    [taxDetails]="selectedTaxDetails" />
  <app-send-to-phone *ngIf="isOpenSendToPhone" [(isOpen)]="isOpenSendToPhone" [isHiddenProcess]="isHiddenProcess"
    [key]="billingId" [communicationTemplate]="CommunicationTemplate.SendBillToPhone" [returnDataOnSuccess]="returnData"
    (onSent)="onSent($event)" />
  <app-more-actions [(isOpenPopup)]="isActionPopupOpen" [items]="moreActionItems" [title]="actionTitle"
    (onClicked)="onMoreActionClicked($event)" />
</div>
<span style="display: none;">
  <button class="after_device_settings_loaded" (click)="onCheckDeviceSettings()">After Device Settings</button>
</span>